// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 06-12-2025

const staffReportActionTypes = {
	/************* GET STAFF DETAILS START ************************** */
	GET_STAFF_DETAILS_START: 'get_staff_details_start',
	GET_STAFF_DETAILS_SUCCESS: 'get_staff_details_success',
	GET_STAFF_DETAILS_FAILURE: 'get_staff_details_failure',
	GET_STAFF_DETAILS_RESPONSE_CHANGED: 'get_staff_details_response_changed',
	GET_STAFF_DETAILS_RESPONSE_RESET: 'get_staff_details_response_reset',
	/************* GET STAFF DETAILS END ************************** */

	/************* GET STAFF OFFICER DETAIL START ************************** */
	GET_STAFF_OFFICER_START: 'get_staff_officer_start',
	GET_STAFF_OFFICER_SUCCESS: 'get_staff_officer_success',
	GET_STAFF_OFFICER_FAILURE: 'get_staff_officer_failure',
	GET_STAFF_OFFICER_RESPONSE_CHANGED: 'get_staff_officer_response_changed',
	GET_STAFF_OFFICER_RESPONSE_RESET: 'get_staff_officer_response_reset',
	/************* GET STAFF OFFICER DETAIL END ************************** */
};
export default staffReportActionTypes;
